async function initMocks() {
  // eslint-disable-next-line unicorn/prefer-global-this
  if (typeof window === 'undefined') {
    const { server } = await import('./server')
    server.listen({ onUnhandledRequest: 'bypass' })
  } else {
    const { worker } = await import('./browser')
    await worker.start({ quiet: true })
  }
}

// eslint-disable-next-line unicorn/prefer-top-level-await
void initMocks()

export {}
